import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top main-nav">
      <div className="container-fluid">
        <Link to="/" className="navbar-brand navbar-logo"><img src={require(`../pages//img/voilalogomin.png`)} alt="VoilaLogo" className='logoimg' /></Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-center navbar-links" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <Link to="/" className="nav-link service-info"><span className="nav-title">Inicio</span></Link>
            </li>
            <li className="nav-item">
              <Link to="/team" className="nav-link service-info"><span className="nav-title">Equipo</span></Link>
            </li>
            <li className="nav-item">
              <Link to="/services" className="nav-link service-info"><span className="nav-title">Servicios</span></Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link service-info"><span className="nav-title">Contacto</span></Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;